import consumer from "./consumer"

consumer.subscriptions.create("BadgeDisplayChannel", {
  received(data) {
    setTimeout(function () {
      console.log("received: ", data);

      const { badge, customer_id } = data;
      const badgeId = `${badge}-${customer_id}`;

      // Get ONLY the target slide
      const $activeSlide = $(".badge-detail__slide-js[data-badge-id='" + badgeId + "']");

      // Safety check
      if ($activeSlide.length === 0) return;

      // Get the modal that contains this slide
      const $badgeModal = $activeSlide.closest("#badgeDetailModalGlobal");

      // Remove active state ONLY inside this modal
      $badgeModal.find(".badge-detail__slide-js").removeClass("is-active");

      // Activate only the target slide
      $activeSlide.addClass("is-active");

      // Open modal
      $badgeModal.addClass("is-active");
      $("body").css("overflow", "hidden");

      // Scoped close handlers (namespaced to avoid duplicates)
      $badgeModal.find("[data-action='close-modal'], [data-action='claim-modal']")
        .off("click.badgeModal")
        .on("click.badgeModal", function () {
          $badgeModal.removeClass("is-active");
          $("body").css("overflow", "");
        });
    }, 1); 
  }
})
